let viewed_products =JSON.parse(localStorage.getItem('ViewedProducts'));
if(viewed_products != null){
viewed_products.forEach((item, index)  => {
        fetch(`/products/${item}`).then(function (response) {
            return response.text();
        }).then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var viewed = doc.querySelector('.js-recently-view').querySelector('.product-box');
            viewed.style.order=index+1;
            $('.js-viewed-products .catalog-product__list').append(viewed)
            console.log(viewed_products.length)
            console.log(">"+index)
            if(viewed_products.length == index+1){
                $('.js-viewed-products').removeClass('loading')
            }
        }).catch(function (err) {

            console.error('Something went wrong.', err);
        });
});
    $('.js-header-viewed-empty').hide()
}else{
    $('.js-header-viewed-top').hide()
     $('.js-viewed-products').removeClass('loading')
}
